var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.795,
    height: 18.794,
    viewBox: "0 0 18.795 18.794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#58595b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.78,11.052A7.585,7.585,0,0,1,6.49,6.746a.644.644,0,0,1,.185-.539L8.127,4.755a.648.648,0,0,0,.091-.8L5.907.364a.648.648,0,0,0-.84-.236L1.356,1.876A.645.645,0,0,0,1,2.519a17.936,17.936,0,0,0,5.462,10.85,17.931,17.931,0,0,0,10.85,5.462.645.645,0,0,0,.644-.356L19.7,14.764a.648.648,0,0,0-.235-.838l-3.589-2.311a.648.648,0,0,0-.8.091l-1.451,1.452a.644.644,0,0,1-.539.185A7.585,7.585,0,0,1,8.78,11.052Z",
    transform: "translate(-0.997 -0.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.157,16.8a.648.648,0,0,1-.648-.648A4.866,4.866,0,0,0,28.648,11.3a.648.648,0,1,1,0-1.3A6.164,6.164,0,0,1,34.8,16.157.648.648,0,0,1,34.157,16.8Z",
    transform: "translate(-19.25 -6.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.4,10.045a.648.648,0,0,1-.648-.648,8.11,8.11,0,0,0-8.1-8.1.648.648,0,1,1,0-1.3,9.408,9.408,0,0,1,9.4,9.4.648.648,0,0,1-.648.648Z",
    transform: "translate(-19.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.6f35033c158284b0dd9cd93d97cd8af4.svg";
export { ForwardRef as ReactComponent };